import React from "react";
import logo from "./logo.svg";
import Layout, { TAB_LOOKUP } from "./Layout";
import ArrowButton from "./ArrowButton";
import "./ConclusionScreen.scss";
import { Link } from "react-router-dom";
import image from "./images/conclusion-mobile.png";
import { t } from "i18next";

function ConclusionScreen() {

 console.log (process.env.REACT_APP_LANGUAGE || "en")

 let locale = process.env.REACT_APP_LANGUAGE || "en";

 let url="https://www.avaya.com/"+locale+"/onecloud/";
 
  return (
    <div className="conclusion-screen-container">
      <div className="mobile-hero">
        <img src={image} alt="woman on the street talking on a phone" />
      </div>
      <div className="conclusion-screen-white-gradient">
        <div className="container conclusion-screen-text-container">
          <h2 className="blue-header">{t("Conclude.title")}</h2>
          <div style={{ marginTop: 10 }} />
          <p>{t("Conclude.description")}</p>
          <div style={{ marginTop: 30 }} />
          <div className="row">
            <p style={{ marginRight: 10 }}>
              <a
                href="https://www.avaya.com/de/onecloud/"
                className="blue-button-outline-container drop-shadow"
                style={{ width: "250px" }}
              >
                {t("Conclude.button1")}
              </a>
            </p>
            <p>
              <a
                href="https://ccaas.avaya.com/cp-de-onecloud-ccaas-better-serve-reg?CTA=21GL-CCAAS-DG&TAC=21GL-CCAAS-DG-SRV-DE-CO"
                className="blue-button-outline-container drop-shadow"
                style={{ width: 200 }}
              >
                {t("Conclude.button2")}
              </a>
            </p>			
			
          </div>
        </div>
      </div>
      <ArrowButton to="/awards" side="left"></ArrowButton>
    </div>
  );
}

export default ConclusionScreen;
